const React = require('react');

const Content = require('../common/Content.jsx');
const ItemV2 = require('../common/ItemV2.jsx');
const Token = require('../utility/Token.jsx');
const Utilities = require('../utility/Utilities.jsx');

function _Meta(props) { return <Content.Value {...props} value={props.content} /> }
const Meta = Token.withContentTokenParsing(_Meta, {}, (props, keyword, options) => {
    if (!props.itemData) {
        return '';
    }
    return Token.TypeParsing.inventory(props, keyword, options);
});
const TokensMeta = (data) => {
    return [
        Token.getWrappedTokenConfig('Artist Name', Token.Artist.Name),
        Token.getWrappedTokenConfig('Artist Lifespan', Token.Artist.Lifespan),
        Token.getWrappedTokenConfig('Title', Token.Inventory.Title),
        Token.getEditionInfoTokenConfig(),
        Token.getWrappedTokenConfig('Created Date', Token.Date),
        Token.getWrappedTokenConfig('Medium', Token.Inventory.Medium),
        Token.getWrappedTokenConfig('Signature Placement', Token.Inventory.Signature),
        Token.getWrappedTokenConfig('Dimensions', Token.Inventory.Dimensions),
        Token.getWrappedTokenConfig('Alternate Dimensions', Token.Inventory.AlternateDimensions),
        Token.getWrappedTokenConfig('Framing', Token.Inventory.Framed),
        Token.getWrappedTokenConfig('Inventory Number', Token.Inventory.Number),
        Token.getWrappedTokenConfig('SKU', Token.Inventory.SKU),
        Token.getWrappedTokenConfig('Location', Token.Inventory.Location),
        Token.getCurrencyTokenConfig('Retail Price', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Inventory.Price),
        Token.getAlternatePricesTokenConfig(),
        Token.getWrappedTokenConfig('Price Override', Token.Inventory.DisplayPrice),
        Token.getWrappedTokenConfig('Notes', Token.Notes),
        Token.getWrappedTokenConfig('Private Notes', Token.PrivateNotes),
    ]
};
const TypeConfigMeta = {
    defaultDesign: (data) => `
${Utilities.wrapTextForEditor({ text: `{${Token.Artist.Name}("before":"","after":"")}`, token: Token.Artist.Name })}
<p class="p">${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;"`, token: Token.Inventory.Title, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Edition}("limited":"${Utilities.Inventory.getEditionFormatString('limited')}","unlimited":"${Utilities.Inventory.getEditionFormatString('unlimited')}")}`, textExtras: `style="display:inline;"`, token: Token.Inventory.Edition, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Date, wrapWithTag: false })}</p>
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Medium}("before":"","after":"")}`, token: Token.Inventory.Medium })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Signature}("before":"Signature: ","after":"")}`, token: Token.Inventory.Signature })}
<p class="p">${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Dimensions}("before":"","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Inventory.Dimensions, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.AlternateDimensions}("before":" (","after":")")}`, textExtras: `style="display:inline;"`, token: Token.Inventory.AlternateDimensions, wrapWithTag: false })}</p>
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Framed}("before":"","after":"")}`, token: Token.Inventory.Framed })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Number}("before":"Inventory #: ","after":"")}`, token: Token.Inventory.Number })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.SKU}("before":"SKU: ","after":"")}`, token: Token.Inventory.SKU })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Price}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Inventory.Price })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.DisplayPrice}("before":"","after":"")}`, token: Token.Inventory.DisplayPrice })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Location}("before":"","after":"")}`, token: Token.Inventory.Location })}`,
    panel: {
        block: (data, defaultDesign) => ItemV2.Meta.TypeConfig.panel.block(defaultDesign || TypeConfigMeta.defaultDesign(data)),
        style: ItemV2.Meta.TypeConfig.panel.style
    }
};

module.exports = {
    Component: Meta,
    Tokens: TokensMeta,
    TypeConfig: TypeConfigMeta
}